import { render, staticRenderFns } from "./ContactChannelCheckboxes.vue?vue&type=template&id=54dfc1a7&scoped=true&"
import script from "./ContactChannelCheckboxes.vue?vue&type=script&lang=ts&"
export * from "./ContactChannelCheckboxes.vue?vue&type=script&lang=ts&"
import style0 from "./ContactChannelCheckboxes.vue?vue&type=style&index=0&id=54dfc1a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dfc1a7",
  null
  
)

export default component.exports